import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { deleteFolder } from '../../services/folders';
import type { Folder } from '../../types';

interface DeleteFolderDialogProps {
  open: boolean;
  onClose: () => void;
  folder: Folder;
  onDeleted: () => void;
}

export default function DeleteFolderDialog({ open, onClose, folder, onDeleted }: DeleteFolderDialogProps) {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await deleteFolder(folder.id);
      onClose();
      onDeleted();
    } catch (err) {
      console.error('Failed to delete folder:', err);
      alert('Failed to delete folder. Check console for details.');
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Delete Folder</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete &ldquo;{folder.name}&rdquo;?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Items in this folder will not be deleted.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="error" onClick={handleDelete} disabled={deleting}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
